import { Link } from "react-router-dom";
import { product } from "@/mocks/product";
import { useWhatsAppOrder } from "@/hooks/useWhatsAppOrder";

export default function CTASection() {
  const sectionRef = useRef<HTMLDivElement>(null);
  const { openModal } = useWhatsAppOrder();

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            el.classList.add("animate-fade-in");
            observer.unobserve(el);
          }
        });
      },
      { threshold: 0.15 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="py-10 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="relative rounded-2xl overflow-hidden">
          <div className="w-full h-[300px] md:h-[400px] bg-gradient-to-br from-[#5B2A42] to-[#D98AA0]" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent" />
          <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-white mb-3">
              Ready to wear it?
            </h2>
            <p className="text-white/80 text-sm md:text-base max-w-lg mb-6">
              Get the Flower Printed Set delivered to your doorstep. Flat ₹30
              shipping across India.
            </p>
            <div className="flex flex-col items-center gap-3">
              <a
                href="https://rzp.io/rzp/neoroop-flower-printed-set"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 px-8 py-3 bg-primary-500 text-white rounded-lg font-medium hover:bg-secondary-500 transition-colors whitespace-nowrap"
              >
                Buy Now
                <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
              </a>
              <button
                type="button"
                onClick={() => openModal(product.name)}
                className="inline-flex items-center gap-1.5 text-xs text-white/60 hover:text-secondary-400 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line w-3.5 h-3.5 flex items-center justify-center" />
                or order on WhatsApp
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}